// src/components/InfoButton/InfoButton.tsx
/* eslint-disable max-len */
import React, { FC, useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import './InfoButton.less';

interface InfoButtonProps {
  content: JSX.Element;
}

const InfoButton: FC<InfoButtonProps> = ({ content }) => {
  const { t } = useTranslation();
  const [showRules, setShowRules] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    setShowRules((current) => !current);
    setIsActive((current) => !current);
  };

  return (
    <>
      <button
        type="button"
        className={isActive ? 'active' : ''}
        onClick={handleClick}
        id="infoButton"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path fillRule="evenodd" clipRule="evenodd" fill="currentColor" d="M2.31934 16.6807C2.29299 16.6244 2.26675 16.5684 2.24087 16.5125C1.60482 15.1395 1.25 13.6102 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C10.786 22.75 9.72211 22.5765 8.72366 22.2194C7.83036 21.8998 7.46428 21.7705 7.35382 21.7445C6.68259 21.5866 6.0471 21.8925 5.41652 22.196C5.00937 22.392 4.60427 22.587 4.1929 22.6555C3.06842 22.8429 2.06787 21.9222 2.16118 20.7861C2.19452 20.3801 2.35166 20.0332 2.50977 19.6842C2.61162 19.4593 2.71389 19.2336 2.78372 18.9906C3.01855 18.1734 2.66113 17.4103 2.31934 16.6807ZM12 6.75C11.3096 6.75 10.75 7.30964 10.75 8C10.75 8.69036 11.3096 9.25 12 9.25C12.6904 9.25 13.25 8.69036 13.25 8C13.25 7.30964 12.6904 6.75 12 6.75ZM12.75 11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V16Z" />
        </svg>
        {t('games:buttons.rules')}
      </button>

      {/* Portal — poza menu opcji, które po kliknięciu się chowa */}
      {showRules && ReactDOM.createPortal(
        <div
          className="rules-overlay"
          role="button"
          tabIndex={0}
          onClick={handleClick}
          onKeyPress={handleClick}
        >
          <div className="rules-content">
            {content}
          </div>
        </div>,
        document.body,
      )}
    </>
  );
};

export default InfoButton;
